module.exports = __webpack_public_path__ + "img/72dcb.a65fec8a.svg";